<template>
  <van-popup
    v-model="visible"
    position="bottom"
    safe-area-inset-bottom
    :style="{ height: '100%' }"
    :lazy-render="false"
    @close="$emit('close')"
    @open="$emit('open')"
    @opened="$emit('opened')"
  >
    <div class="popup-title">
      <van-icon class="icon" name="arrow-left" @click="hidePopup" />
      <span class="text">
        {{ title }}
      </span>
    </div>
    <slot />
    <div class="submit-box">
      <van-button class="submit" block type="info" @click="submit">
        确定
      </van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'WhPopup',
  model: {
    event: 'change',
    prop: 'visible'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    refForm: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      myForm: undefined
    }
  },
  methods: {
    hidePopup() {
      this.$emit('change', false)
      this.$emit('close')
    },
    submit() {
      if (this.refForm) {
        this.refForm.submit()
      }
      this.$emit('submit')
    }
  }
}
</script>

<style lang='less' scoped>
.popup-title  {
    margin-top: 16px;
    text-align: center;
    position: relative;
    .icon {
      position: absolute;
      left: 10px;
      font-size: 18px;
      top: 4px;
    }
    .text {
      font-weight: bold;
      letter-spacing: 0.1em;
      color: #333333;
      font-size: 20px;
    }
}
.submit-box {
  @height: 40px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .submit {
    height: @height;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    padding: 20px 0 30px 0;
  }
}
</style>
